
export default function Footer() {
    return (
            <footer className="footer footer-center bg-primary text-primary-content p-10">
            <aside>
                <img className="w-[60px]" src="./renteasy.png" alt="" />
                <p className="font-bold">
                RentEasy
                <br />
                Providing reliable tech since 2025
                </p>
                <p>Copyright © 2025 - All right reserved</p>
            </aside>
            </footer>
    )
    
}


